import {AfterContentChecked, Component, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import {CoreConfigurationService} from '../../core-configuration.service';
import {Router} from '@angular/router';
import {PopupService} from '../popup.service';

@Component({
    selector: 'app-page-content',
    templateUrl: './page-content.component.html',
    styleUrls: ['./page-content.component.css'],
    standalone: false
})
export class PageContentComponent implements OnInit, AfterContentChecked {
  @Input() pageTitle: string;
  @Input() subTitle: string;
  @Input() enableMenuButton = false;
  @Input() showSearchBox = false;
  @Input() showProgress = false;
  @Input() showBackButton = false;
  @Input() useMobileHeaderColors: boolean;
  @Input() filterInputs: TemplateRef<any>;

  @Output() searchQueryChange = new EventEmitter();
  @Output() filterChanged = new EventEmitter();

  @ViewChild('menuButton', {read: ElementRef})
  menuButton: ElementRef;

  @ViewChild('filterButtonHeader', {read: ElementRef})
  filterButtonHeader: ElementRef;

  @ViewChild('filterButtonSearch', {read: ElementRef})
  filterButtonSearch: ElementRef;

  @ViewChild('footer', {read: ElementRef})
  footerElement: ElementRef;

  private _searchQuery: string;

  private referringUrl;

  @Input()
  get searchQuery() {
    return this._searchQuery;
  }
  set searchQuery(val) {
    this._searchQuery = val;
    this.searchQueryChange.emit(this._searchQuery);
  }

  @Output() search: EventEmitter<string> = new EventEmitter();

  constructor(
    public coreConfiguration: CoreConfigurationService,
    private router: Router,
    private navigationService: PopupService) {
  }

  ngOnInit() {
    this.referringUrl = this.coreConfiguration.referringUrl;
  }

  ngAfterContentChecked() {
    if (this.menuButton != null && this.menuButton.nativeElement != null) {
      this.menuButton.nativeElement.blur();
    }

    if (this.filterButtonHeader != null && this.filterButtonHeader.nativeElement != null) {
      this.filterButtonHeader.nativeElement.blur();
    }

    if (this.filterButtonSearch != null && this.filterButtonSearch.nativeElement != null) {
      this.filterButtonSearch.nativeElement.blur();
    }
  }

  openMenu() {
    this.coreConfiguration.sidenav.open();
  }

  menuButtonEnabled() {
    return (this.coreConfiguration.showMenu && this.coreConfiguration.isMobile) && this.enableMenuButton;
  }

  backButtonEnabled() {
    return this.referringUrl != null && this.showBackButton;
  }

  navigateBack() {
    this.router.navigateByUrl(this.referringUrl);
  }

  showFilterDialog() {
    /*if (this.filterInputs != null) {
      this.navigationService.openInPopupFromComponent(FilterDialogComponent, {filterInputs: this.filterInputs}, {height: '30vh', width: '80vw'})
        .subscribe(() => {
          this.filterChanged.emit();
        });
    }*/
  }

  showMobileSearchBox() {
    return this.showSearchBox && this.coreConfiguration.isMobile;
  }

  getPageContentMaxHeightCssCalculation() {
    let childElementCount = 0;

    if (this.footerElement != null) {
      childElementCount = this.footerElement.nativeElement.childElementCount;
    }

    return `calc(100% ${childElementCount > 0 ? '- 128px' : '- 64px'} ${this.showMobileSearchBox() ? '- 64px' : ''})`;
  }
}
